export default "__VITE_ASSET__DGj_cDx3__"